import { Spinner } from "@components/ui-kit";
import { useGetBrandsLazyQuery } from "@src/__generated__/graphql";
import { withCan } from "@src/utils/components/permissions";
import { useUpdateURI } from "@src/utils/hooks/useUpdateURI";
import { getParamFromQuery } from "@src/utils/url";
import { observer } from "mobx-react-lite";
import { useRouter } from "next/router";
import React, { useEffect, useState } from "react";
import { CardListBrands } from "./CardListBrands";
import { StoreBrands } from "./StoreBrands";

// context holding page related data
export const PageBrandsCtx = React.createContext<StoreBrands>(
  null as any as StoreBrands,
);

/**
 * encapsulate initial data fetch & refetch
 */
function useData(store: StoreBrands) {
  const [fetchBrands, { data, loading, error, refetch }] =
    useGetBrandsLazyQuery({
      notifyOnNetworkStatusChange: true,
      onCompleted(data) {
        store.fromGetBrandsQuery(data);
      },
    });

  useEffect(() => {
    fetchBrands({ variables: store.queryParams });
  }, [store.queryParams]);

  store.refetch = refetch;

  return { loading, error, data };
}

export const PageBrands = withCan(
  { do: "brand_read" },
  observer(function PageBrands() {
    const { query } = useRouter();

    const [store] = useState(() => {
      const store = StoreBrands.create();
      store.searchTerm = getParamFromQuery("search", query) ?? "";
      store.where.fromURLSearchParam(query);
      store.orderBy.fromURLSearchParam(query);
      store.pagination.fromURLSearchParam(query);
      return store;
    });

    useUpdateURI(store.searchParams);

    const { loading } = useData(store);

    return (
      <PageBrandsCtx.Provider value={store}>
        <div className="flex justify-center items-center">
          <div className="w-full">
            {loading && <Spinner absolute />}
            <CardListBrands />
          </div>
        </div>
      </PageBrandsCtx.Provider>
    );
  }),
);
